// ================================
// 🛒 ENHANCED CART COUNT UPDATE FUNCTION (Global Scope)
// ================================
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const itemCount = cart.item_count;
      
      // ULTRA-CONSERVATIVE: Only target span/div elements that are clearly count badges
      // Exclude anything that might be a parent container or the cart icon itself
      const cartCountElements = document.querySelectorAll(
        '.cart-count:not(a):not(button):not([href]), ' +
        '.cart-count-bubble:not(a):not(button), ' +
        '.cart-link__bubble:not(a):not(button), ' +
        '.site-header__cart-count:not(a):not(button), ' +
        '.header__cart-count:not(a):not(button), ' +
        '.cart__count:not(a):not(button), ' +
        '.mini-cart__count:not(a):not(button), ' +
        '.bag-count:not(a):not(button), ' +
        '.basket-count:not(a):not(button), ' +
        'span[data-cart-count], ' +
        'div[data-cart-count]:not([class*="icon"]):not([class*="cart-link"])'
      );
      
      // Ultra-safe update: Only touch text content and minimal attributes
      cartCountElements.forEach(el => {
        // Triple check: Skip if this element contains an SVG or IMG (it's the icon!)
        if (el.querySelector('svg') || el.querySelector('img') || el.querySelector('use')) {
          console.log('⚠️ Skipping element with icon:', el);
          return;
        }
        
        // Skip if this is a parent link or has href
        if (el.closest('a') === el || el.hasAttribute('href')) {
          console.log('⚠️ Skipping link element:', el);
          return;
        }
        
        // SAFE: Only update text and data attribute
        el.textContent = itemCount;
        el.setAttribute('data-cart-count', itemCount);
        
        // Only show/hide if it has specific bubble classes
        if (el.classList.contains('cart-count-bubble') || 
            el.classList.contains('cart-link__bubble')) {
          if (itemCount > 0) {
            el.style.display = '';
          } else {
            el.style.display = 'none';
          }
        }
        
        console.log('✅ Updated cart count element:', el.className || el.id);
      });
      
      // Dispatch global cart update event for theme compatibility
      document.dispatchEvent(new CustomEvent('cart:refresh', { 
        detail: { itemCount, cart },
        bubbles: true 
      }));
      
      // Trigger Shopify theme events if available
      if (window.Shopify && window.Shopify.theme) {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:updated', { 
            bubbles: true,
            detail: { cart }
          })
        );
      }
      
      // Theme-specific refresh methods (safest approach)
      if (typeof theme !== 'undefined' && theme.cart && typeof theme.cart.updateCount === 'function') {
        try {
          theme.cart.updateCount(itemCount);
        } catch (e) {
          console.warn('Theme cart update failed:', e);
        }
      }
      
      console.log('✅ Cart count updated to:', itemCount);
    })
    .catch(err => {
      console.error('❌ Failed to update cart count:', err);
    });
}

// Additional function to force refresh all cart-related UI elements
function forceCartRefresh() {
  // Update count
  updateCartCount();
  
  // Force refresh cart drawer/mini-cart if present
  const cartDrawer = document.querySelector('cart-drawer, [data-cart-drawer], .cart-drawer');
  if (cartDrawer && typeof cartDrawer.refresh === 'function') {
    cartDrawer.refresh();
  }
  
  // Trigger section refresh for themes that use sections
  if (window.Shopify && window.Shopify.theme && window.Shopify.theme.sections) {
    const cartSection = document.querySelector('[data-section-type="cart"]');
    if (cartSection) {
      const sectionId = cartSection.dataset.sectionId;
      if (sectionId && typeof window.Shopify.theme.sections.load === 'function') {
        window.Shopify.theme.sections.load(sectionId);
      }
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const parseJSONScript = (id) => {
    const el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); }
    catch (err) { console.warn(`Failed to parse JSON for #${id}`, err); return null; }
  };

  const updateMainImage = (tabContent, imgSrc) => {
    const mainImg = tabContent.querySelector('.product-image-wrapper img');
    if (mainImg && imgSrc) mainImg.src = imgSrc;
  };

  document.querySelectorAll('.product-section-tabs').forEach(section => {
    const tabs = section.querySelectorAll('.tab-btn');
    const contents = section.querySelectorAll('.tab-content');

    // --- TAB SWITCHING ---
    if (tabs.length && contents.length) {
      tabs.forEach((b, i) => {
        b.classList.toggle('active', i === 0);
        b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      });
      contents.forEach((c, i) => {
        c.classList.toggle('active', i === 0);
        c.hidden = i !== 0;
      });
    }

    section.addEventListener('click', e => {
      const btn = e.target.closest('.tab-btn');
      if (!btn) return;
      e.preventDefault();
      const targetId = btn.dataset.target;
      tabs.forEach(b => {
        const isTarget = b.dataset.target === targetId;
        b.classList.toggle('active', isTarget);
        b.setAttribute('aria-selected', isTarget ? 'true' : 'false');
      });
      contents.forEach(c => {
        const isTarget = c.id === targetId;
        c.classList.toggle('active', isTarget);
        c.hidden = !isTarget;
      });
    });

    // Thumbnail click handler
    section.addEventListener('click', e => {
      const thumb = e.target.closest('.variant-thumb, .thumbnail-img');
      if (!thumb) return;
      e.preventDefault();

      const tabContent = thumb.closest('.tab-content');
      if (!tabContent) return;

      const imgSrc = thumb.dataset.full || thumb.dataset.imageSrc || thumb.src;
      const variantId = thumb.dataset.variantId;

      // 1. Update main image
      if (imgSrc) updateMainImage(tabContent, imgSrc);

      // 2. Highlight clicked thumbnail
      tabContent.querySelectorAll('.variant-thumb, .thumbnail-img')
        .forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');

      // 3. Sync corresponding radio
      if (variantId) {
        const radio = tabContent.querySelector(`input[type="radio"][value="${variantId}"]`);
        if (radio) {
          radio.checked = true;

          // 4. Fire change event so existing radio logic runs
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      // ✅ Sync corresponding radio button
      if (variantId) {
        const radio = tabContent.querySelector(`.product-1-colors input[type="radio"][value="${variantId}"]`);
        if (radio) {
          radio.checked = true;
        }
      }
    });

    // --- PRODUCT 1: Handle Filter & Color Radio Changes ---
    section.addEventListener('change', e => {
      const radio = e.target.closest('.product-1-filters input[type="radio"], .product-1-colors input[type="radio"]');
      if (!radio) return;
      
      const tabContent = radio.closest('.tab-content');
      if (!tabContent) return;

      // Get both selections
      const selectedFilter = tabContent.querySelector('.product-1-filters input[type="radio"]:checked');
      const selectedColor = tabContent.querySelector('.product-1-colors input[type="radio"]:checked');
      
      // Update price only if BOTH are selected
      if (selectedFilter && selectedColor && selectedFilter.dataset.price) {
        const priceEl = tabContent.querySelector('.price');
        if (priceEl) {
          // Parse filter base price
          const filterPrice = parseFloat(selectedFilter.dataset.price.replace(/[^0-9.]/g, ''));
          
          // Parse color price difference (could be 0 for base color)
          const colorDiff = selectedColor.dataset.price ? 
            parseFloat(selectedColor.dataset.price.replace(/[^0-9.]/g, '')) : 0;
          
          // Calculate: Base filter price + color difference
          const totalPrice = filterPrice + colorDiff;
          const currency = selectedFilter.dataset.price.match(/[^\d.]/g)?.[0] || '£';
          
          priceEl.textContent = `${currency}${totalPrice.toFixed(2)}`;
        }
      }

      // Sync thumbnail with color selection
      if (radio.closest('.product-1-colors')) {
        const variantId = radio.value;
        const thumb = tabContent.querySelector(`.variant-thumb[data-variant-id="${variantId}"], .thumbnail-img[data-variant-id="${variantId}"]`);
        if (thumb) {
          updateMainImage(tabContent, thumb.dataset.full || thumb.dataset.imageSrc);
          tabContent.querySelectorAll('.variant-thumb, .thumbnail-img')
            .forEach(t => t.classList.remove('active'));
          thumb.classList.add('active');
        }
      }
    });

    section.addEventListener('click', async e => {
      const link = e.target.closest('.button_design-basket');
      if (!link) return;

      e.preventDefault();
      e.stopPropagation();

      const tabContent = link.closest('.tab-content');
      if (!tabContent) return;

      // Check if this is Product 1 (has both filters and colors)
      const isProduct1 = tabContent.querySelector('.product-1-filters') !== null;
      
      if (!isProduct1) return; // Let Product 2 handler deal with it

      const statusEl = tabContent.querySelector('.product-1-status') || (() => {
        const s = document.createElement('div');
        s.className = 'product-1-status';
        link.insertAdjacentElement('afterend', s);
        return s;
      })();

      // Get both selected options
      const selectedFilter = tabContent.querySelector('.product-1-filters input[type="radio"]:checked');
      const selectedColor = tabContent.querySelector('.product-1-colors input[type="radio"]:checked');

      if (!selectedFilter || !selectedColor) {
        statusEl.textContent = 'Please select both filter and color.';
        statusEl.style.color = 'red';
        statusEl.style.display = 'block';
        return;
      }

      // Get product data
      if (!window.product1Data) {
        statusEl.textContent = 'Product data not loaded.';
        statusEl.style.color = 'red';
        statusEl.style.display = 'block';
        console.error('window.product1Data is not available');
        return;
      }

      const productData = window.product1Data;
      
      // Get filter option value - find the parent label and get the second blue-small span
      let filterValue = null;
      const filterLabel = selectedFilter.closest('.variant-label');
      if (filterLabel) {
        const blueSmalls = filterLabel.querySelectorAll('.blue-small');
        if (blueSmalls.length >= 2) {
          filterValue = blueSmalls[1].textContent.trim(); // Second one is the filter name
        }
      }

      // Get color option value - from the label text
      let colorValue = null;
      const colorLabel = selectedColor.closest('.color-rect');
      if (colorLabel) {
        const labelEl = colorLabel.querySelector('label');
        if (labelEl) {
          // Get only the text node, not the diff div
          colorValue = labelEl.childNodes[0]?.textContent?.trim() || labelEl.textContent.trim().split('\n')[0].trim();
        }
      }

      console.log('Filter value:', filterValue);
      console.log('Color value:', colorValue);

      if (!filterValue || !colorValue) {
        statusEl.textContent = 'Could not determine selection.';
        statusEl.style.color = 'red';
        statusEl.style.display = 'block';
        console.error('Missing values:', { filterValue, colorValue });
        return;
      }

      // Find matching variant
      let matchedVariant = null;
      
      // Strategy 1: Match by option1 and option2
      matchedVariant = productData.variants.find(v => {
        return v.option1 === filterValue && v.option2 === colorValue;
      });

      // Strategy 2: Match by title if Strategy 1 fails
      if (!matchedVariant) {
        matchedVariant = productData.variants.find(v => {
          const titleLower = (v.title || '').toLowerCase();
          return titleLower.includes(filterValue.toLowerCase()) && 
                 titleLower.includes(colorValue.toLowerCase());
        });
      }

      if (!matchedVariant) {
        statusEl.textContent = 'Variant not found.';
        statusEl.style.color = 'red';
        statusEl.style.display = 'block';
        console.error('Could not find variant for:', { filterValue, colorValue });
        console.log('Available variants:', productData.variants.map(v => ({ 
          title: v.title, 
          option1: v.option1, 
          option2: v.option2,
          price: v.price 
        })));
        return;
      }

      console.log('✅ Found variant:', matchedVariant);

      link.textContent = 'Adding…';
      link.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: Number(matchedVariant.id), quantity: 1 })
        });

        if (!res.ok) throw new Error('Add to cart failed');
        await res.json();

        // 🎯 ENHANCED: Update cart count with multiple methods
        updateCartCount();
        
        // Force additional refresh after short delay to catch any delayed UI updates
        setTimeout(() => {
          forceCartRefresh();
        }, 100);
        
        // Another refresh after 500ms for themes with animations
        setTimeout(() => {
          updateCartCount();
        }, 500);

        statusEl.textContent = 'Added to basket!';
        statusEl.style.color = 'green';
        statusEl.style.display = 'block';
        
        setTimeout(() => {
          statusEl.style.display = 'none';
        }, 3000);
      } catch (err) {
        statusEl.textContent = err.message || 'Something went wrong';
        statusEl.style.color = 'red';
        statusEl.style.display = 'block';
      } finally {
        link.textContent = 'Add to Shopping Basket';
        link.disabled = false;
      }
    });

    // --- INITIALIZE FIRST THUMBNAIL ACTIVE ---
    contents.forEach(tab => {
      const firstThumb = tab.querySelector('.product-1 .variant-thumb, .product-1 .thumbnail-img');
      if (firstThumb) firstThumb.classList.add('active');
    });
  });
});

// ================================
// 🧩 PRODUCT 2 VARIANT HANDLER WITH DYNAMIC PACK PRICES
// ================================
document.addEventListener("DOMContentLoaded", () => {
  const product2 = document.querySelector(".product-right-col.product-2");
  if (!product2) return;

  console.log("🚀 Product 2 script initialized");

  // Target the correct price element within Product 2
  const priceEl2 = product2.querySelector("h1.price");
  console.log('Product 2 Price Element:', priceEl2);

  // Parse product data
  if (!window.product2Data) {
    console.error('Product 2 data not found');
    return;
  }

  const product2Data = window.product2Data;
  console.log('Product 2 Data:', product2Data);

  let currentVariant = null;

  // --- Update pack size prices based on selected filter ---
  function updatePackPrices() {
    const filterVal = document.querySelector(".product-2-filter-type input:checked")?.value;
    
    if (!filterVal) {
      console.warn("⚠️ No filter selected yet");
      return;
    }

    console.log("🔄 Updating pack prices for filter:", filterVal);

    // Find all pack size radio buttons
    const packRadios = document.querySelectorAll(".product-2-pack-size input[type='radio']");
    
    packRadios.forEach(radio => {
      const packVal = radio.value;
      const searchTitle = `${filterVal} / ${packVal}`.trim();
      
      // Find the variant for this combination
      const variant = product2Data.variants.find(
        v => v.title.toLowerCase().trim() === searchTitle.toLowerCase()
      );

      if (variant) {
        const price = (variant.price / 100).toFixed(2);
        const currency = "£"; // Or use Shopify.currency.active
        
        // Find the price display element for this radio
        const label = radio.closest('.radio-item-2');
        if (label) {
          const priceSpan = label.querySelector('.price-small');
          if (priceSpan) {
            priceSpan.textContent = ` - ${currency}${price}`;
            console.log(`✅ Updated ${packVal} price to ${currency}${price}`);
          }
        }
      }
    });
  }

  // --- Main variant selection + price update ---
  function updateVariantSelection() {
    const filterVal = document.querySelector(".product-2-filter-type input:checked")?.value;
    const packVal = document.querySelector(".product-2-pack-size input:checked")?.value;

    console.group("🧩 Product 2 Variant Update");
    console.log("Filter:", filterVal || "❌ none");
    console.log("Pack:", packVal || "❌ none");

    // Stop if one of them isn't selected yet
    if (!filterVal || !packVal) {
      console.warn("⚠️ Waiting for both selections...");
      console.groupEnd();
      return null;
    }

    // Combine both for search
    const searchTitle = `${filterVal} / ${packVal}`.trim();
    console.log("👉 Combined selection:", searchTitle);

    // Find correct variant by combined title
    currentVariant = product2Data.variants.find(
      v => v.title.toLowerCase().trim() === searchTitle.toLowerCase()
    );

    if (!currentVariant) {
      console.error("❌ No variant found for:", searchTitle);
      console.log("Available variants:", product2Data.variants.map(v => v.title));
      if (priceEl2) priceEl2.textContent = "–";
      console.groupEnd();
      return null;
    }

    console.log("✅ Matched variant:", currentVariant.title, "ID:", currentVariant.id);

    // Update main price
    if (priceEl2 && currentVariant?.price) {
      const price = (currentVariant.price / 100).toFixed(2);
      const currency = "£";
      const priceText = `${currency}${price}`;

      priceEl2.textContent = priceText;
      console.log("💰 Updated main price to:", priceText);
    }

    console.groupEnd();
    return currentVariant.id;
  }

  // --- Listen for filter type changes ---
  const filterInputs = document.querySelectorAll(".product-2-filter-type input");
  filterInputs.forEach(input => {
    input.addEventListener("change", () => {
      console.log("🔄 Filter changed to:", input.value);
      updatePackPrices(); // Update pack prices first
      updateVariantSelection(); // Then update main price
    });
  });

  // --- Listen for pack size changes ---
  const packInputs = document.querySelectorAll(".product-2-pack-size input");
  packInputs.forEach(input => {
    input.addEventListener("change", () => {
      console.log("🔄 Pack size changed to:", input.value);
      updateVariantSelection(); // Just update main price
    });
  });

  // Product 2 Add to Cart Handler
  const product2Button = document.querySelector('.product-2-bubblewrapper .button_design-basket');
  const statusEl2 = document.querySelector('.product-2-status');

  if (product2Button && statusEl2) {
    product2Button.addEventListener('click', async e => {
      e.preventDefault();

      const selectedFilter = document.querySelector('.product-2-filter-type input[type="radio"]:checked');
      const selectedPack = document.querySelector('.product-2-pack-size input[type="radio"]:checked');

      if (!selectedFilter || !selectedPack) {
        statusEl2.textContent = 'Please select both filter type and pack size.';
        statusEl2.style.color = 'red';
        statusEl2.style.display = 'block';
        return;
      }

      // Get the current variant from updateVariantSelection
      const variantId = updateVariantSelection();

      if (!variantId) {
        statusEl2.textContent = 'Please select valid options.';
        statusEl2.style.color = 'red';
        statusEl2.style.display = 'block';
        return;
      }

      console.log('🛒 Adding Product 2 to cart, variant ID:', variantId);

      product2Button.textContent = 'Adding…';
      product2Button.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: 1
          })
        });

        if (!res.ok) throw new Error('Add to cart failed');
        await res.json();

        // 🎯 ENHANCED: Update cart count with multiple methods
        updateCartCount();
        
        // Force additional refresh after short delay to catch any delayed UI updates
        setTimeout(() => {
          forceCartRefresh();
        }, 100);
        
        // Another refresh after 500ms for themes with animations
        setTimeout(() => {
          updateCartCount();
        }, 500);

        statusEl2.textContent = 'Added to basket!';
        statusEl2.style.color = 'green';
        statusEl2.style.display = 'block';

        setTimeout(() => {
          statusEl2.style.display = 'none';
        }, 3000);
      } catch (err) {
        console.error('❌ Error adding to basket:', err);
        statusEl2.textContent = 'Error adding to basket';
        statusEl2.style.color = 'red';
        statusEl2.style.display = 'block';
      } finally {
        product2Button.textContent = 'Add to Shopping Basket';
        product2Button.disabled = false;
      }
    });
  }

  // Initial setup - update pack prices on load
  updatePackPrices();
  updateVariantSelection();
});

// ================================
// 🔄 GLOBAL CART REFRESH ON PAGE LOAD
// ================================
// Ensure cart count is updated when page loads
window.addEventListener('load', () => {
  updateCartCount();
});

// Also update on visibility change (when user returns to tab)
document.addEventListener('visibilitychange', () => {
  if (!document.hidden) {
    updateCartCount();
  }
});